import { CodedProperty, NamedProperty } from "sprint-common-web";

import { ContentDetails } from "../../../../../../../../common/types/ContentDetails";
import { RecordType } from "../../../../../../../../common/types/RecordType";
import { ConformingCloudAsset } from "../../../../../../../api/GetConformingCloudAssetsResponse";

export type BulkEditCloudAssetContentItem =
    | ConformingCloudVideoAssetItem
    | ConformingCloudAudioAssetItem
    | ConformingCloudSubtitleAssetItem;

interface BulkEditCloudAssetContentItemBase {
    id: string;
    filepath: string;
    content: ContentDetails;
}

export interface ConformingCloudVideoAssetItem extends BulkEditCloudAssetContentItemBase {
    recordType: RecordType.Video;
    uniquenessKey: { aspectRatio: NamedProperty; subtitleLanguage: CodedProperty };
}

export interface ConformingCloudAudioAssetItem extends BulkEditCloudAssetContentItemBase {
    recordType: RecordType.Audio;
    uniquenessKey: { soundtrackLanguage: CodedProperty };
}

export interface ConformingCloudSubtitleAssetItem extends BulkEditCloudAssetContentItemBase {
    recordType: RecordType.Subtitle;
    uniquenessKey: { subtitleLanguage: CodedProperty; subtitleType: number };
}

export const mapToBulkEditCloudAssetContentItem = (item: ConformingCloudAsset): BulkEditCloudAssetContentItem => {
    return {
        id: item.id,
        filepath: item.path,
        recordType: item.recordType,
        uniquenessKey: mapToUniquenessKey(item),
        content: item.content
    } as BulkEditCloudAssetContentItem;
};

const mapToUniquenessKey = (item: ConformingCloudAsset) => {
    switch (item.recordType) {
        case RecordType.Video:
            return { aspectRatio: item.aspectRatio, subtitleLanguage: item.subtitle };
        case RecordType.Audio:
            return { soundtrackLanguage: item.soundtrack };
        case RecordType.Subtitle:
            return { subtitleLanguage: item.subtitle, subtitleType: item.subtitleType };
        default:
            throw new Error("Unsupported cloud asset record type");
    }
};
